$(document).ready(function () {
var $slider = $(".custom-banner-slider");

$slider.on('init', function(event, slick) {
    if (slick.slideCount <= 1) {
        $slider.find('.slick-dots').hide();
    }
});

$slider.slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    pauseOnFocus: false,
    fade: true,
    cssEase: "linear"
});


  $(".brand-slider").slick({
    dots: false,
    autoplay: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-left.png?v=1690454089' alt='Left arrow' width='33' height='33'></button>",
    nextArrow:
      "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-right.png?v=1690454120' alt='Right arrow' width='33' height='33'></button>",
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".popcat_cover").slick({
    arrows: true,
    dots: false,
    autoplay: false,
      prevArrow:
      "<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-left.png?v=1690454089' alt='Left arrow' width='33' height='33'></button>",
    nextArrow:
      "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-right.png?v=1690454120' alt='Right arrow' width='33' height='33'></button>",
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
         //centerMode: true,
         // centerPadding: "60px",
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
         // centerMode: true,
         // centerPadding: "60px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Custom Featured Collection Slider
  $(".custom_featured_collection").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-left.png?v=1690454089" alt="Previous" width="33" height="33">/button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-right.png?v=1690454120" alt="Next" width="33" height="33"></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

 
});

 // Related Product Slider
  function initializeSlickSlider() {
      
         $(".related-products-slider").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-left.png?v=1690454089" alt="Previous" width="33" height="33">/button>',
      nextArrow:
        '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/1235/2902/files/brand-arror-right.png?v=1690454120" alt="Next" width="33" height="33"></button>',
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    }

    // Check if content has loaded, and initialize Slick Slider when ready
    var checkContentInterval = setInterval(function() {
      if ($('.related-products-slider').children().length > 0) {
        initializeSlickSlider(); // Initialize the Slick Slider
        clearInterval(checkContentInterval); // Clear the interval
        
      }
    }, 100); // Adjust the interval duration as needed


//$('.related-products-slider').slick('setPosition');

var $div = $('.main-banner ').eq(1);
$div.css('display', 'block');

var $div = $('.popcat-section ').eq(1);
$div.css('display', 'block');

var $div = $('.brand_logo ').eq(1);
$div.css('display', 'block');


document.addEventListener("DOMContentLoaded", function () {
    const submenus = document.querySelectorAll(".hover-menu .submenu_wrapper");
    submenus.forEach(submenu => {
        submenu.style.display = "block";
    });
});

